import { useEffect, useState } from "react";
import {
  FiArchive,
  FiBarChart,
  FiBook,
  FiFeather,
  FiHome,
  FiList,
  FiLogOut,
  FiMenu,
  FiSettings,
  FiX,
  FiRefreshCw,
  FiPlus,
  FiUserCheck,
} from "react-icons/fi";
import { useSelector } from "react-redux";
import service from "../service";
import * as Sidebar from "./Sidebar";
import { useCookies } from "react-cookie";
import BigLoader from "./BigLoader";
import Button from "./Button";

export default function Layout({ children }) {
  const [menuShown, setMenuShown] = useState(false);
  const {
    interface: { rightButton, ...web },
  } = useSelector((state) => state);
  const [loading, setLoading] = useState(false);
  const removeCookie = useCookies()[2];
  const { role = "super" } = useCookies()[0];
  const [sidemenu, setSidemenu] = useState([]);

  const _logout = () => {
    setLoading(true);
    service
      .delete("/api/auth/logout")
      .then(() => {
        setLoading(false);
        service.defaults.headers.common["Authorization"] = undefined;
        removeCookie("id", { path: "/" });
        removeCookie("username", { path: "/" });
        removeCookie("token", { path: "/" });
        removeCookie("role", { path: "/" });
        removeCookie("admin_logged_in", { path: "/" });
      })
      .catch(() => {
        setLoading(false);
        removeCookie("id", { path: "/" });
        removeCookie("username", { path: "/" });
        removeCookie("token", { path: "/" });
        removeCookie("role", { path: "/" });
        removeCookie("admin_logged_in", { path: "/" });
      });
  };

  useEffect(() => {
    if (role === "super") {
      setSidemenu([
        {
          name: "Dashboard",
          path: "/",
          icon: FiHome,
        },
        {
          name: "Statistik",
          path: "/stats",
          icon: FiBarChart,
        },
        {
          name: "Kategori",
          path: "/category",
          icon: FiArchive,
        },
        {
          name: "Ring",
          path: "/content",
          icon: FiBook,
        },
        {
          name: "Deep Read",
          path: "/deep-read",
          icon: FiBook,
        },
        {
          name: "Online Course",
          path: "/course",
          icon: FiFeather,
        },
        {
          name: "Reviews",
          path: "/review",
          icon: FiFeather,
        },
        {
          name: "Users",
          path: "/users",
          icon: FiUserCheck,
        },
        {
          name: "Pesanan",
          path: "/order",
          icon: FiList,
        },
        {
          name: "Affiliate",
          path: "/affiliate",
          icon: FiBarChart,
        },
        {
          name: "Settings",
          path: "/settings",
          icon: FiSettings,
        },
        {
          name: "Landing Page",
          path: "/landing-page",
          icon: FiFeather,
        },
      ]);
    }
  }, [role]);
  return (
    <div className="h-screen overflow-auto flex bg-background">
      {menuShown && (
        <div
          className="bg-black-100 opacity-40 position fixed top-0 left-0 w-full h-screen block lg:hidden z-30"
          onClick={() => {
            setMenuShown(false);
          }}
        ></div>
      )}
      <div
        className={
          "w-11/12 md:w-64 bg-white-100 h-full overflow-auto flex flex-col border-r border-white-200 fixed lg:static top-0 left-0 z-30 transform transition-all duration-300 " +
          (menuShown ? "-translate-x-0" : "-translate-x-full") +
          " lg:translate-x-0"
        }
      >
        <div className="mb-3 h-16 border-b border-white-200 flex items-center">
          <h1 className="text-xl montserrat-alternates px-5 font-bold flex-1 text-primary-600">
            Admin Panel
          </h1>
          <button
            className="w-8 h-8 mr-3 flex lg:hidden justify-center items-center text-black-400"
            type="button"
            onClick={() => {
              setMenuShown(false);
            }}
          >
            <FiX />
          </button>
        </div>
        <Sidebar.Wrapper>
          {sidemenu.map((item, index) =>
            item.dropdown ? (
              <Sidebar.DropdownList
                key={`menu-${index}`}
                icon={item.icon}
                active={web.active.split("/")[0] === item.name}
                dropdownActive={
                  web.active.split("/").length > 1
                    ? web.active.split("/")[1]
                    : null
                }
                dropdown={item.dropdown}
                dropdownOnClick={() => {
                  setMenuShown(false);
                }}
              >
                {item.name}
              </Sidebar.DropdownList>
            ) : (
              <Sidebar.List
                onClick={() => {
                  setMenuShown(false);
                }}
                key={`menu-${index}`}
                to={item.path}
                icon={item.icon}
                active={web.active === item.name}
              >
                {item.name}
              </Sidebar.List>
            )
          )}
        </Sidebar.Wrapper>
        <div className="px-3 mb-3">
          <button
            onClick={() => _logout()}
            type="button"
            className="rounded-lg px-3 py-2.5 text-sm font-semibold w-full flex items-center text-black-300 hover:bg-red-50 hover:text-red-300 transition-colors"
          >
            <span className="w-8 text-center text-lg">
              <FiLogOut />
            </span>
            Keluar
          </button>
        </div>
      </div>
      <div className="flex-1 overflow-auto h-screen">
        <div className="h-16 bg-primary-500 lg:bg-white-100 border-b border-primary-600 lg:border-white-200 flex items-center p-5 sticky top-0 z-20 lg:shadow-card">
          <button
            className="w-8 h-8 mr-3 flex lg:hidden justify-center items-center text-white-100"
            type="button"
            onClick={() => {
              setMenuShown(true);
            }}
          >
            <FiMenu />
          </button>
          <h1 className="font-bold text-lg flex-1 text-white-100 lg:text-black-200">
            {web.pageTitle}
          </h1>
          {rightButton ? (
            <div className="ml-3 flex items-center">
              <Button
                link
                to={rightButton.to}
                color={rightButton.color || "green"}
                noFixedHeight
                className="h-10 px-3 flex justify-center items-center"
              >
                {rightButton.withPlusIcon ? <FiPlus className="mr-1" /> : null}
                {rightButton.label}
              </Button>
            </div>
          ) : null}
        </div>
        <div className="p-5">{children}</div>
      </div>
      {loading && <BigLoader />}
    </div>
  );
}
